var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-4"
  }, [_c('v-card', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    }
  }, [_c('v-card-text', {
    staticClass: "pt-0 pb-1"
  }, [_c('v-row', {
    staticClass: "pb-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "outlined": "",
      "rounded": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "search",
      "append-icon": "mdi-magnify"
    },
    on: {
      "change": _vm.searchUpdated
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.batches,
      "item-key": "xid",
      "server-items-length": _vm.batches_total,
      "options": _vm.options,
      "footer-props": {
        itemsPerPageOptions: [10, 20, 50]
      },
      "show-expand": "",
      "single-expand": "",
      "expanded": _vm.expandedRows
    },
    on: {
      "update:options": function updateOptions($event) {
        _vm.options = $event;
      },
      "update:expanded": function updateExpanded($event) {
        _vm.expandedRows = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.created_at",
      fn: function fn(_ref) {
        var item = _ref.item,
          value = _ref.value;
        return [_c('Moment', {
          staticClass: "font-weight-medium",
          attrs: {
            "timestamp": value,
            "mode": "datetime"
          }
        })];
      }
    }, {
      key: "item.jobs",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.jobs.length) + " ")];
      }
    }, {
      key: "item.charges",
      fn: function fn(_ref3) {
        var value = _ref3.value;
        return [_vm._v(_vm._s(_vm.formatCents(value)))];
      }
    }, {
      key: "item.charges_discount",
      fn: function fn(_ref4) {
        var value = _ref4.value;
        return [_vm._v(_vm._s(_vm.formatCents(value)))];
      }
    }, {
      key: "item.subtotal",
      fn: function fn(_ref5) {
        var value = _ref5.value;
        return [_vm._v(_vm._s(_vm.formatCents(value)))];
      }
    }, {
      key: "item.tax",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(_vm._s(_vm.formatCents(item.tax)))];
      }
    }, {
      key: "item._actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [item.ready ? [_c('v-menu', {
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref8) {
              var on = _ref8.on,
                attrs = _ref8.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "color": "primary",
                  "title": "Export"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-download")])];
            }
          }], null, true)
        }, [_c('v-list', {
          attrs: {
            "dense": ""
          }
        }, [_c('v-subheader', [_vm._v("Download")]), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_pdf(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "red"
          }
        }, [_vm._v("mdi-file-document")]), _vm._v("PDF Summary ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_myob(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "purple"
          }
        }, [_vm._v("mdi-file-table")]), _vm._v("MYOB AccountRight ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_xero(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "blue lighten-1"
          }
        }, [_vm._v("mdi-file-table")]), _vm._v("Xero ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_xero2(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "blue lighten-1"
          }
        }, [_vm._v("mdi-file-table")]), _vm._v("Xero v2 ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_zoho(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "blue darken-2"
          }
        }, [_vm._v("mdi-file-table")]), _vm._v("Zoho Books ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_summary_csv(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "green"
          }
        }, [_vm._v("mdi-file-table")]), _vm._v("Export CSV ")], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function click($event) {
              return _vm.batch_zip(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-4",
          attrs: {
            "color": "orange"
          }
        }, [_vm._v("mdi-folder-zip")]), _vm._v("Zip Archive ")], 1)], 1)], 1)] : _c('v-chip', {
          staticClass: "warning",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("Processing")])];
      }
    }, {
      key: "expanded-item",
      fn: function fn(_ref9) {
        var headers = _ref9.headers;
        return [_c('td'), _c('td', {
          staticClass: "pa-2",
          attrs: {
            "colspan": headers.length - 1
          }
        }, [_c('v-data-table', {
          staticClass: "transparent",
          attrs: {
            "headers": _vm.invoiceHeaders,
            "items": _vm.filteredInvoices,
            "items-per-page": -1,
            "item-key": "xid",
            "loading": _vm.loading,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([{
            key: "item.ref",
            fn: function fn(_ref10) {
              var item = _ref10.item,
                value = _ref10.value;
              return [_c('a', {
                attrs: {
                  "title": "View Invoice"
                },
                on: {
                  "click": function click($event) {
                    return _vm.viewInvoice(item);
                  }
                }
              }, [_vm._v(_vm._s(value))])];
            }
          }, {
            key: "item.customer",
            fn: function fn(_ref11) {
              var value = _ref11.value;
              return [_c('a', {
                attrs: {
                  "title": "Open Customer in New Tab"
                },
                on: {
                  "click": function click($event) {
                    return _vm.openCustomerInNewTab(value);
                  }
                }
              }, [_vm._v(_vm._s(value.name))])];
            }
          }, {
            key: "item.location",
            fn: function fn(_ref12) {
              var value = _ref12.value;
              return [value ? _c('span', {
                staticClass: "text-caption"
              }, [_vm._v(" " + _vm._s(value.company_name)), _c('br'), _vm._v(" " + _vm._s(value.city_locality) + " " + _vm._s(value.state_province) + " " + _vm._s(value.postal_code) + " ")]) : _vm._e()];
            }
          }, {
            key: "item.charges",
            fn: function fn(_ref13) {
              var value = _ref13.value;
              return [_vm._v(_vm._s(_vm.formatCents(value)))];
            }
          }, {
            key: "item.charges_discount",
            fn: function fn(_ref14) {
              var value = _ref14.value;
              return [_vm._v(_vm._s(_vm.formatCents(value)))];
            }
          }, {
            key: "item.subtotal",
            fn: function fn(_ref15) {
              var value = _ref15.value;
              return [_vm._v(_vm._s(_vm.formatCents(value)))];
            }
          }, {
            key: "item.tax",
            fn: function fn(_ref16) {
              var item = _ref16.item;
              return [_vm._v(_vm._s(_vm.formatCents(item.tax)))];
            }
          }, {
            key: "item.total",
            fn: function fn(_ref17) {
              var item = _ref17.item;
              return [_vm._v(_vm._s(_vm.formatCents(item.total)))];
            }
          }, {
            key: "item._actions",
            fn: function fn(_ref18) {
              var item = _ref18.item;
              return [_c('v-menu', {
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function fn(_ref19) {
                    var on = _ref19.on,
                      attrs = _ref19.attrs;
                    return [_c('v-btn', _vm._g(_vm._b({
                      attrs: {
                        "fab": "",
                        "small": "",
                        "text": ""
                      }
                    }, 'v-btn', attrs, false), on), [_c('v-icon', {
                      attrs: {
                        "color": "secondary"
                      }
                    }, [_vm._v("mdi-dots-horizontal")])], 1)];
                  }
                }], null, true)
              }, [_c('v-list', {
                attrs: {
                  "dense": ""
                }
              }, [_c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function click($event) {
                    return _vm.viewInvoice(item);
                  }
                }
              }, [_c('v-icon', {
                staticClass: "mr-4",
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v("mdi-open-in-new")]), _vm._v("View Invoice ")], 1), _c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadInvoice(item);
                  }
                }
              }, [_c('v-icon', {
                staticClass: "mr-4",
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v("mdi-download")]), _vm._v("Download Invoice ")], 1), _c('v-divider'), _c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function click($event) {
                    return _vm.revise(item);
                  }
                }
              }, [_c('v-icon', {
                staticClass: "mr-4",
                attrs: {
                  "color": "warning"
                }
              }, [_vm._v("mdi-file-restore")]), _vm._v("Revise Invoice ")], 1), _c('v-divider'), _c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function click($event) {
                    return _vm.resend(item);
                  }
                }
              }, [_c('v-icon', {
                staticClass: "mr-4",
                attrs: {
                  "color": "warning"
                }
              }, [_vm._v("mdi-send")]), _vm._v("Re-send Invoice ")], 1)], 1)], 1)];
            }
          }], null, true)
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selection,
      callback: function callback($$v) {
        _vm.selection = $$v;
      },
      expression: "selection"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }